export default "__VITE_ASSET__BGa_Za95__"